// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3pCv7","label":"Radio_label__3lwvi","checkMark":"Radio_checkMark__iR12V","disabled":"Radio_disabled__2-dlS"};